import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function FacebookRoundIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 1365.3333 1357.04">
      <path fill="currentColor" d="M1365.3333 682.6667C1365.3333 305.64 1059.6933 0 682.6666 0S0 305.64 0 682.6667c0 340.7386 249.6413 623.1597 576 674.3733V880H402.6667V682.6667H576v-150.4c0-171.0933 101.9173-265.6 257.8533-265.6 74.6893 0 152.8133 13.3333 152.8133 13.3333v168H900.584c-84.804 0-111.2507 52.6227-111.2507 106.6094v128.0573h189.3333L948.4 880H789.3333v477.04c326.3587-51.2136 576-333.6347 576-674.3733"/>
    </SvgIcon>
  )
}

export default FacebookRoundIcon
